// JsFromRoutes CacheKey 757fa08777e8172e9770f64cf9771052
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/consumer/contacts/:contact_id/information_requests'),
}
